<template>
  <div class="input-wrap-row">
    <div class="input-wrap-row__field">
      <slot name="first" />
    </div>

    <div class="input-wrap-row__operator">
      <font-awesome-icon v-if="operationIcon" :icon="operationIcon" />
    </div>

    <div class="input-wrap-row__field">
      <slot name="second" />
    </div>

    <div class="input-wrap-row__operator">
      <font-awesome-icon v-if="resultIcon" :icon="resultIcon" />
    </div>

    <div class="input-wrap-row__field">
      <slot name="result" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "InputWrapRow",
  props: {
    operationIcon: {
      type: [String, Array, Object],
      default: "",
    },
    resultIcon: {
      type: [String, Array, Object],
      default: "",
    },
  },
});
</script>

<style scoped lang="scss">
.input-wrap-row {
  display: grid;
  grid-template-columns:
    minmax(0, 1fr) auto
    minmax(0, 1fr) auto
    minmax(0, 1fr);
  column-gap: 1rem;
  width: 100%;
}

.input-wrap-row__field {
  min-width: 0;
}

.input-wrap-row__operator {
  align-items: center;
  align-self: start;
  display: flex;
  height: calc(1.5em + 0.75rem + 2px);
  justify-content: center;
  margin-top: 2.25rem;
}
</style>
